import { authorizeManageMissionByAccessSharing } from '../../../../backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
export function useAuthorizeManageMission() {
    const userState = useUserState();
    const authorizeManageMission = (missionAccessSharing, missionTypeId) => {
        return authorizeManageMissionByAccessSharing({ userState, missionAccessSharing, missionTypeId });
    };
    return { authorizeManageMission };
}
